module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8f519ed30404968835efe89f9befdd32.gif";